import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _VaSplit } from "./VaSplit-e5e79926.mjs";
const VaSplit = withConfigTransport(_VaSplit);
export {
  VaSplit as V
};
//# sourceMappingURL=index-9ef6d1e5.mjs.map
